try {
  // Run "npm run features" to generate features.json
  const featureConfig = require('../../generated/features.json')
  module.exports = featureConfig
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error)
}
